import React from 'react';
import Markdown, { MarkdownToJSX } from 'markdown-to-jsx';
import { css } from '@emotion/react';

export interface MarkdownWrapperProps {
  /** The custom components to use for the markdown */
  overrides?: MarkdownToJSX.Overrides;
  /** The markdown content to render */
  children?: React.ReactNode | string | null;
}

export const MarkdownWrapper: React.FC<MarkdownWrapperProps> = ({ children, overrides }) => {
  if (!children) {
    return null;
  }

  return React.isValidElement(children) || typeof children !== 'string' ? (
    children
  ) : (
    <Markdown css={defaultStyles} options={{ overrides }}>
      {children}
    </Markdown>
  );
};

const defaultStyles = css({
  '& > p:first-of-type': {
    margin: 0,
  },
});
